export default {
    BjDialogListConfig: {
        code: 'Product code',
        name: 'Product name',
        orderNo: 'Order No.',
        POCode: 'Warehouse Receipt Number',
        POShippingMethod: 'Shipping Method',
        POContainerId: 'Container Id',
        POStatus: 'Status',
        classification: 'Product category',
        entercode: 'Please enter code',
        entername: 'Please enter name',
        selectcategory: 'Please select category',
        SKUcode: 'SKU',
        SKUname: 'Product Name',
        Producttype: 'Product type',
        enterproductname: 'Please enter the product name',
        enterproductcode: 'Please enter the product code',
        enterSKUcode: 'Please enter the SKU code',
        Storecode: 'Store code',
        Storename: 'Store name',
        Storetype: 'Store type',
        Codes: 'Code',
        Names: 'Name',
        Saleschannel: 'Sales Channel',
        Types: 'Type',
        enteronlinestorecode: 'Please enter the store code',
        enteronlinestorename: 'Please enter the store name',
        selectchannel: 'Please select a channel',
        Warehousecode: 'Warehouse code',
        Warehousename: 'Warehouse name',
        Warehouseaddress: 'Warehouse address',
        Internalordernumber: 'CSG Order No.',
        Thirdordernumber: 'Customer Order No.',
        Ordertype: 'Order Type',
        Orderstatus: 'Status',
        Salesstore: 'Store',
        Paymentstatus: 'Payment status',
        Itemquantity: 'Number of Item Lines',
        goodsamount: 'Total product amount',
        TotalOrderAmount: 'Total order amount',
        Buyerpayable: 'Buyer payment',
        goodscost: 'Total product cost',
        Buyerpayment: 'Buyer actual payment',
        Shipmentstatus: 'Delivery status',
        Receivingstatus: 'Receipt status',
        Buyernickname: 'Buyer nickname',
        Consigneename: 'Consignee name',
        Phone: 'Phone number',
        Shippingaddress: 'Shipping address',
        Threepartyorder: '3rd Party Order Time',
        Paymenttime: 'Payment time',
        Creationtime: 'Creation time',
        Tripartitenumber: 'Customer Order No. / Internal Order No.',
        TripartiteId: 'Customer order ID / WMS ID',
        WMSOrderNo: 'WMS Order No',
        giftor: 'Whether it is a gift',
        Circulationstatus: 'Circulation status',
        Writestatus: 'Write-back status',
        Platformstatus: 'Platform receipt status',
        itemsNumber: 'Number of products',
        Discounttotal: 'Total discounts',
        Totalamount: 'Total amount receivable',
        Merchantamount: 'Merchant bears the discount amount',
        preferentialamount: 'Third party bears the discount amount',
        Orderpulling: 'Pulling time',
        Suppliercode: 'Supplier code',
        Suppliername: 'Supplier name',
        Suppliercommodity: 'Supplier product code',
        Pricetax: 'Tax-included price',
        Taxrate: 'Tax rate',
        entersuppliercode: 'Please enter the supplier code',
        entersuppliername: 'Please enter the supplier name',
        Available: 'Available inventory',
        Number: 'Purchase in transit',
        Minimum: 'Minimum purchase quantity',
        Purchaseorder: 'Purchase Order No.',
        Purchasetype: 'Purchase type',
        Warehousingstatus: 'Inbound status',
        Receivingwarehouse: 'Receiving warehouse',
        Purchasequantity: 'Purchase quantity',
        Receiptquantity: 'Quantity received',
        Quantityreceived: 'Quantity not received',
        Stopwaiting: 'Quantity on hold',
        Operationtime: 'Operation time',
        Operator: 'Operator',
        Operationtype: 'Operation type',
        Remarks: 'Remarks',
    },
    ExcelConfig: {
        Title: 'Import',
        Import: 'Excel Import Rule Description:',
        AfterDownload: 'After downloading the Excel template, the system will automatically match. If the system has already automatically matched, the matching relationship will be overwritten based on the imported content;',
        ImportExcel: 'Excel Import Template, Click to Download:',
        Download: 'Template Download',
        MustHave: 'Importing Excel format must have a title, with red titles being mandatory;',
        MustBe: 'After importing the Excel module, the original order information will be overwritten according to the imported content;',
        Supports: 'Supports: CSV, xls, and xlsx formats. The file size for a single import cannot exceed 128MB, and the data row cannot exceed 60000 rows. If it exceeds, please import multiple times.',
        maximum: 'The maximum upload file size cannot exceed 128M',
        maximum2: 'The maximum upload file size cannot exceed 30M',
        Confirm: 'Confirm Import',
        submitted: 'The file has been submitted, you can go to the import history page to view the import results',
        failedTemplate: 'Failed to obtain template',
        upload: 'Please upload the file first',
        excelNumberLimit: 'The number of excel items is too large. Please split the items. The maximum number is 200',
        numberError: 'wrong column number',
        nameError: 'wrong column name',
        integerTip: ' Need to be an integer',
        numberTip: ' Need to be floating number',
        stringTip: ' Need to be string',
        emptyTip: ' can not be empty',
        excelEroorTip: 'Some data is invalid. Please download the feedback file to check the added error column and fix your original file.',
        excelEroorTip1: 'Some data in your uploaded file is invalid or formatted incorrectly.',
        excelEroorTip2: 'Please download the feedback file to check the error column that was added for your reference,',
        excelEroorTip3: 'then correct the issues in your original file and re-upload. and re-upload.',
        tip1: 'must be an integer and cannot be 0',
        tip2: 'must be an integer or a decimal and cannot be 0',
        tip3: 'The barcode cannot exceed 14 characters, nor contain spaces or special characters',
        tip4: 'cannot contain spaces',
        tip5: 'Please ensure the state is entered correctly, e.g., using abbreviations like NSW, VIC, etc.',
        downTip1: 'Download and complete the standard Product information template.The system will automatically map each field during import.If existing product mappings are detected, they will be overwritten by the new data.',
        downTip2: 'Click “Template Download” to obtain the Product import template.',
        downTip3: 'The Excel file must include a header row.Fields highlighted in blue are mandatory.',
        downTip4: 'Supported formats: CSV, XLS, XLSX.Each file must not exceed 128MB or 60,000 rows.If the file exceeds these limits, please split and import in batches.',
        downTip5: 'Drag your file into the upload area or click “Upload” to select a file.',
    }
};
